import type { SectionProps } from '@/components/sitemap/Section';
import { sharedConfig } from '@/pageConfig/shared';
import sections from '@/static/sitemap.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  section: SectionProps[];
}

export const config: Config = {
  layout: { ...sharedConfig['nl-NL'].layout },
  seo: {
    ...sharedConfig['nl-NL'].seo,
    title: 'Verken de site van Lemonade Nederland | Overzicht van alle pagina’s en diensten',
    metaTitle: 'Verken de site van Lemonade Nederland | Overzicht van alle pagina’s en diensten',
    description:
      'Verken de site van Lemonade Nederland voor een overzicht van alle pagina’s, zodat je handige verzekeringsinformatie eenvoudig vindt.',
  },
  section: sections['nl-NL'],
};
